<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">Traffic Configuration</span>
    </div>
    <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
      <Spinner />
    </div>
    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <PaginationTable :pagination="pagin" :columns="trafficConfigListCutomizedColumns" :dataSource="dataTable" :tableSize="tableSize">
            <template slot="configName" slot-scope="{ record }">
              <div class="text-truncate">
                <a-tooltip :title="record.configName">
                  <span>{{ record.configName }}</span>
                </a-tooltip>
              </div>
            </template>
            <template slot="domain" slot-scope="{ record }">
              <a-tooltip>
                <template slot="title">
                  <span>
                    {{ record.domain }}
                  </span>
                </template>
                <div class="text-truncate">
                  <span>{{ record.domain }}</span>
                </div>
                <p class="mb-0">
                  <small>on behalf of {{ record.domainUser }}</small>
                </p>
              </a-tooltip>
            </template>
            <template slot="status" slot-scope="{ record }">
              <a-tag :color="record.status === TrafficStatus.waiting ? TrafficStatusColorTag.waiting : record.status === TrafficStatus.replica ? TrafficStatusColorTag.fallb : TrafficStatusColorTag.failov">
                {{ record.status }}
              </a-tag>
            </template>
            <template slot="lastActivatedBy" slot-scope="{ record }">
              <div class="text-truncate">
                <a-tooltip :title="record.lastActivatedBy">
                  <span>{{ record.lastActivatedBy }}</span>
                </a-tooltip>
              </div>
            </template>
            <template slot="lastActivatedAt" slot-scope="{ record }">
              <div>
                <p class="mb-0">
                  <time>{{ record.lastActivatedAt | dateString }}</time>
                  <br />
                  <time>{{ record.lastActivatedAt | timeString }}</time>
                </p>
              </div>
            </template>
            <template slot="autoFailover" slot-scope="{ record }" >
              <div v-if="featureAccess && featureAccess['auto-failover']">
                <a-dropdown placement="topLeft" class="padd">
                  <a-icon class="operation" type="ellipsis" />
                  <a-menu slot="overlay">
                    <a-menu-item v-if="record.status === TrafficStatus.replica || record.status === TrafficStatus.unknown">
                      <div class="full-wh" @click.prevent="switchDnsRecord(record, 'fallback')">
                        Manual Fallback to Original Server
                      </div>
                    </a-menu-item>
                    <a-menu-item v-if="record.status === TrafficStatus.original_server || record.status === TrafficStatus.unknown">
                      <div class="full-wh" @click.prevent="switchDnsRecord(record, 'failover')">
                        Manual Failover to Replica
                      </div>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
                <a-collapse :bordered="false" expand-icon-position="right">
                  <div class="padd">                    
                    <a-switch :checked ="record.autoFailover === 'ON' ? true : false" checked-children="On" un-checked-children="Off"  @change="onSwitchChange" @click="updateAutoFailoverStatus(record)"/>
                    <div v-if="record.autoFailover === 'ON'" class="paddfailovercheck">                                        
                      <a-tag :color="record.autoFailoverStatus === 'Active' ? TrafficStatusColorTag.failov : TrafficStatusColorTag.fallb ">
                        {{ record.autoFailoverStatus === 'Active' ? 'Active' : 'On Schedule' }}
                      </a-tag>
                    </div>
                  </div>
                  <a-collapse-panel key="1" header="Details">
                    <div v-if="record.trafficDaySchedule && record.trafficDaySchedule.length !== 0">
                      <p> Selected period(s): </p>
                      <div v-for="item in record.trafficDaySchedule" :key="JSON.stringify(item)" class="listcontainer">
                        {{item.start_day}} {{item.start_time}} to {{item.end_day}} {{item.end_time}}
                        <a-icon type="delete" class="deleteicon" @click="deleteDay(record, item)"/>
                      </div>
                      <div class="loader" v-if="record.addLoading">
                        <a-icon type="sync" spin/>
                      </div>
                      <div class="loader" v-if="record.delLoading">
                        <a-icon type="sync" spin/>
                      </div>
                    </div>
                    <div v-else>
                      No periods selected for auto failover. Add a new period below:
                    </div>
                    <div class="container">
                    <label>From:</label>
                      <a-select default-value="Start day" size="large" v-model="record.startPeriodDay">
                        <a-select-option :key="item" v-for="item in DayList"  :value="item">
                          {{item}}
                        </a-select-option>
                      </a-select>
                      <a-time-picker format="HH:mm" size="large" v-model="record.startPeriodTime" />
                    <label>To:</label>
                      <a-select default-value="Start day" size="large" v-model="record.endPeriodDay">      
                        <a-select-option :key="item" v-for="item in DayList" :value="item">
                          {{item}}
                        </a-select-option>
                      </a-select>
                      <a-time-picker format="HH:mm" size="large" v-model="record.endPeriodTime" />
                    </div>
                    <br>
                    <a-button type="primary" @click="addDay(record)"> 
                      Add to schedule
                    </a-button>
                    <div v-show="record.alertPeriodChange">
                      <a-alert type="error" message="Please check that you have selected an appropriate date and time" banner />
                    </div>
                    <br>
                    <br>
                    <div v-if="record.trafficDateSchedule && record.trafficDateSchedule.length !== 0">
                      <p> Selected specific date(s): </p>
                      <div v-for="item in record.trafficDateSchedule" :key="JSON.stringify(item)" class="listcontainer">
                        {{item.start_date}} {{item.start_time}} to {{item.end_date}} {{item.end_time}}
                        <a-icon type="delete" class="deleteicon" @click="deleteDate(record, item)" />
                      </div>
                      <div class="loader" v-if="record.addDateLoading">
                        <a-icon type="sync" spin />
                      </div>
                      <div class="loader" v-if="record.delDateLoading">
                        <a-icon type="sync" spin />
                      </div>     
                    </div>
                    <div v-else>
                      No dates specified for auto failover. Add one below:
                    </div>
                    <div class="container">
                    <label>From:</label>
                      <a-date-picker v-model="record.startDateSpec" />
                      <a-time-picker size="large" format="HH:mm" v-model="record.startDateSpecTime" style="width: 105px" />
                    <label>To:</label>
                      <a-date-picker v-model="record.endDateSpec" />
                      <a-time-picker size="large" format="HH:mm" v-model="record.endDateSpecTime" style="width: 105px" />
                    </div>
                    <br>
                    <a-button type="primary" @click.prevent="addDate(record)"> 
                      Add to schedule
                    </a-button>
                    <div v-show="record.alertDateChange">
                      <a-alert type="error" message="Please check that you have selected an appropriate date and time" banner />
                    </div>
                  </a-collapse-panel>
                </a-collapse>
                <br />
              </div>
              <div v-else>
                Your account is not authorized to use this feature. Please contact WebOrion admin for more information.
              </div>
            </template>
            <template slot="operation" slot-scope="{ record }">
              <a-dropdown placement="topLeft">
                <a-icon class="operation" type="ellipsis" />
                <a-menu slot="overlay">
                  <a-menu-item v-if="record.status === TrafficStatus.replica || record.status === TrafficStatus.unknown">
                    <div class="full-wh" @click.prevent="switchDnsRecord(record, 'fallback')">
                      Fallback to Original Server
                    </div>
                  </a-menu-item>
                  <a-menu-item v-if="record.status === TrafficStatus.original_server || record.status === TrafficStatus.unknown">
                    <div class="full-wh" @click.prevent="switchDnsRecord(record, 'failover')">
                      Failover to Replica
                    </div>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </PaginationTable>
        </template>
      </transition>
    </div>
    <div class="a-footer">
      <PaginationBar :pageSize.sync="pagin.pageSize" :total="pagin.total" @change="paginChange" />
    </div>
  </div>
</template>

<script>
  import { debounce } from 'lodash';
  import Capitalize from '@shared/filters/capitalize.filter';
  import { PAGE_OPTIONS } from '@constants/pageOptions';
  import { DayList, TrafficStatus, TrafficStatusColorTag } from '../consts/TrafficConfig.consts';
  import { TrafficConfigListColumn } from '../columnsTable/TrafficConfigListColumn';
  import TrafficConfigService from '../services/TrafficConfig.service';
  import moment from 'moment';

  export default {
    name: 'TrafficConfigList',
    data() {
      var pageSize = Number(window.localStorage.getItem("pageSize"));
      if(!pageSize)
       pageSize = 5;

      return {
        DayList,
        PAGE_OPTIONS,
        trafficConfigListCutomizedColumns: [],
        TrafficStatus,
        TrafficStatusColorTag,
        dataTable: [],
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0
        },
        isLoading: true,
        addLoading: false,
        delLoading: false,
        tableSize: {
          height: '',
          width: ''
        },
        autoFailoverCheck: false,
      };
    },
    mounted() {
      this.fetchList();
      if (this.featureAccess && this.featureAccess['auto-failover']) {
        // User has auto failover feature enabled
        // Therefore, we hide the "operation" column as the manual failover trigger is inside the auto failover box
        this.trafficConfigListCutomizedColumns = TrafficConfigListColumn.filter((val) => {
          return val['slot'] !== 'operation';
        });
      } else {
        // User does not have auto failover feature enabled
        // Therefore, we hide the "autoFailover" column and show the manual failover dropdown
        this.trafficConfigListCutomizedColumns = TrafficConfigListColumn.filter((val) => {
          return val['slot'] !== 'autoFailover';
        });
      }
    },
    computed: {
      featureAccess() {
        return this.$store.state.user.data.feature_access;
      }
    },
    methods: {
      moment,
      onSwitchChange(checked) {
        if (checked == false) {
          this.autoFailoverCheck = false
        } else {
          this.autoFailoverCheck = true
        }
      },
      updateAutoFailoverStatus(record){        
        const status = record.autoFailover === 'ON' ? 'OFF' : 'ON'
        const titleMsg = 'Are you sure to switch Auto Failover setting to ' + status + ' ?'
        const onMessage = "Your website will failover automatically when alert is detected"
        const offMessage = "Your website will no longer failover automatically when alert is detected"
        this.$confirm({
          title: titleMsg,
          content: (h) => <div> {status === 'ON' ? onMessage : offMessage}  </div>,                                  
          okText: 'Yes',
          okType: 'info',
          cancelText: 'No',
          onOk: async () => {
            if (this.autoFailoverCheck == true) {
              const autoFailoverStatus = "ON"
              await TrafficConfigService.updateAutoFailoverStatus(record.id, autoFailoverStatus)
            } else {
              const autoFailoverStatus = "OFF"
              await TrafficConfigService.updateAutoFailoverStatus(record.id, autoFailoverStatus)
            }
            await this.fetchList()
            this.$showSuccessMessage("Auto Failover setting change requested")
          }            
        });
      },      
      async fetchList() {
        try {
          console.log("test")
          const responseData = await TrafficConfigService.fetchList();
          this.dataTable = (responseData || []).map((item, index) => ({
            index: index + 1,
            id: item.id,
            configName: item.configuration_name || '',
            domain: item.domain_name || '',
            domainUser: item.domain_of_user_website || '',
            status: item.status || '',
            cname: (item.normal_domain_records && item.normal_domain_records.CNAME) || [],
            normalDomainRecords: item.normal_domain_records || [],
            failoverDomainRecords: item.failover_domain_records || [],
            lastActivatedBy: item.last_activated_by || '',
            lastActivatedAt: item.last_activated_at,
            trafficDateSchedule: item.traffic_date_schedule,
            trafficDaySchedule: item.traffic_day_schedule,
            autoFailover: item.traffic_auto_failover,
            autoFailoverStatus: item.traffic_auto_failover_status,
            addLoading: false,
            addDateLoading: false,
            delLoading: false,
            delDateLoading: false,
            alertPeriodChange: false,
            alertDateChange: false,
            startPeriodDay: "Start Day",
            startPeriodTime: null,
            endPeriodDay: "End Day",
            endPeriodTime: null,
            startDateSpec: null,
            startDateSpecTime: null,
            endDateSpec: null,
            endDateSpecTime: null
          }));
          this.pagin.total = responseData.length || 0;
        } catch (error) {
          this.$showErrorMessage('HTTP error received from web server.!');
          console.log(error)
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      },
      switchDnsRecord(record, mode) {
        let content = {};
        if (mode == "failover") {
          content = record.failoverDomainRecords;
        } else {
          content = record.normalDomainRecords;
        }

        let contentFormatted = [];
        for (const type in content) {
          if (type === 'TTL') {
            // ignore TTL values
          } else {
            for (let i = 0; i < content[type].length; i++) {
              //contentStr += `${type} ${content[type][i]}\n`;
              contentFormatted.push({'type': type, 'value': content[type][i]});
            }
          }
        }

        this.$confirm({
          title: 'This will switch the DNS records to the following:',
          content: (h) =>
            <div>
              {contentFormatted.map(line => (
                        <div>{line.type} {line.value}</div>
                ))}
            </div>,
          okText: 'Yes',
          okType: 'info',
          cancelText: 'No',
          onOk: async () => {
            if(record.status !== TrafficStatus.replica){
              await TrafficConfigService.failOverTraffic(record.id)
            } else {
              await TrafficConfigService.fallbackTraffic(record.id);
            }
            this.$showSuccessMessage(Capitalize(status));
            record.status = TrafficStatus.waiting;
            this.fetchList();
          }
        });
      },
      addDay(record) {
        if (record.startPeriodDay != "Start Day" && record.startPeriodTime!= null && record.endPeriodDay != "End Day" && record.endPeriodTime != null) {
          let startPeriodTime = record.startPeriodTime.format("HH:mm");
          let endPeriodTime = record.endPeriodTime.format("HH:mm");
          record.alertPeriodChange = false
          let periodList = record.trafficDaySchedule;
          if (!periodList) {
            periodList = [];
          }
          const periodAdded = {
            start_day: record.startPeriodDay,
            start_time: startPeriodTime,
            end_day: record.endPeriodDay,
            end_time: endPeriodTime
          };
          this.$confirm({
            title: 'Are you sure to add this period to schedule? ',
            content: (h) => <div> {periodAdded.start_day} {periodAdded.start_time} to {periodAdded.end_day} {periodAdded.end_time} </div>,
            okText: 'Yes',
            okType: 'info',
            cancelText: 'No',
            onOk: async () => {
              record.addLoading = true
              periodList.push(periodAdded)
              await TrafficConfigService.updateAutoFailoverSchedule(record.id, {traffic_day_schedule: periodList})
              await this.fetchList()
              this.$showSuccessMessage("Date updated successfully");
              record.addLoading = false
            }
          });
        }
        else {
          record.alertPeriodChange = true
        }
      },
      addDate(record) {
        let startDate = moment((record.startDateSpec).format("YYYY-MM-DD") + " " + (record.startDateSpecTime).format("HH:mm"), "YYYY-MM-DD hh:mm:ss");
        let endDate = moment((record.endDateSpec).format("YYYY-MM-DD") + " "+ (record.endDateSpecTime).format("HH:mm"), "YYYY-MM-DD hh:mm:ss");

        if (startDate.isBefore(endDate) && record.startDateSpec != null && record.startDateSpecTime!= null && record.endDateSpec != null && record.endDateSpecTime != null) {
          //let startDateSpec = JSON.parse(JSON.stringify(record.startDateSpec.format("YYYY-MM-DD")))
          //let startDateSpecTime = JSON.parse(JSON.stringify(record.startDateSpecTime.format("HH:mm")))
          //let endDateSpec = JSON.parse(JSON.stringify(record.startDateSpecTime.format("YYYY-MM-DD")))
          //let endDateSpecTime = JSON.parse(JSON.stringify(record.startDateSpecTime.format("HH:mm")))
          record.alertDateChange = false;
          let dateList = record.trafficDateSchedule;
          if (!dateList) {
            dateList = [];
          }
          const dateAdded = {
            start_date: moment(record.startDateSpec).format("YYYY-MM-DD"),
            start_time: moment(record.startDateSpecTime).format("HH:mm"),
            end_date: moment(record.endDateSpec).format("YYYY-MM-DD"),
            end_time: moment(record.endDateSpecTime).format("HH:mm")
          };
          this.$confirm({
            title: 'Are you sure to add this date to schedule? ',
            content: (h) => <div> {dateAdded.start_date} {dateAdded.start_time} to {dateAdded.end_date} {dateAdded.end_time} </div>,
            okText: 'Yes',
            okType: 'info',
            cancelText: 'No',
            onOk: async () => {
              record.addDateLoading = true;
              dateList.push(dateAdded);
              await TrafficConfigService.updateAutoFailoverSchedule(record.id, {traffic_date_schedule: dateList});
              await this.fetchList();
              this.$showSuccessMessage("Date updated successfully");
              record.addDateLoading = false;
            }
          });
        }        
        else {
          record.alertDateChange = true
        }
      },
      deleteDay(record, p) {
        let periodLists = record.trafficDaySchedule
        this.$confirm({
          title: 'Are you sure to delete this period from schedule? ',
          content: (h) => <div> {p.start_day} {p.start_time} to {p.end_day} {p.end_time}  </div>,
          okText: 'Yes',
          okType: 'info',
          cancelText: 'No',
          onOk: async () => {
            record.delLoading = true
            periodLists = periodLists.filter((period)=>period!==p)
            await TrafficConfigService.updateAutoFailoverSchedule(record.id, {traffic_day_schedule: periodLists})
            await this.fetchList()
            this.$showSuccessMessage("Date updated successfully")
            record.delLoading = false
          },
        });
      },
      deleteDate(record, d) {
        let dateLists = record.trafficDateSchedule
        this.$confirm({
          title: 'Are you sure to delete this date from schedule? ',
          content: (h) => <div> {d.start_date} {d.start_time} to {d.end_date} {d.end_time} </div>,
          okText: 'Yes',
          okType: 'info',
          cancelText: 'No',
          onOk: async () => {
            record.delDateLoading = true
            dateLists = dateLists.filter((date)=>date!==d)
            await TrafficConfigService.updateAutoFailoverSchedule(record.id, {traffic_date_schedule: dateLists})
            await this.fetchList()
            this.$showSuccessMessage("Date updated successfully")
            record.delDateLoading = false
          }
        });
      },
      paginChange(pagin) {
        this.pagin = { ...pagin };
      },
      elSizeChange(size) {
        this.tableSize = size;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .time-text {
    margin-bottom: 0;
    white-space: nowrap;
  }
  .nav-link-detail {
    width: 100%;
    &:hover {
      text-decoration: underline;
    }
  }
  .nav-link-detail {
    display: inline-block;
  }
  .custom-suffix {
    font-size: 20px;
    color: #20a4b8;
  }
  .webpab-ext-link {
    color: inherit;
    display: block;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:hover {
      color: #20a4b8;
      text-decoration: underline;
    }
  }

  .container{
    display: grid;
    grid-template-columns: 40px 1fr 1fr;
    grid-gap: 5px;
    margin: auto 0px;
  }
  .container label{
    margin: auto 0px;
  }
  .listcontainer{
    display: grid;
    grid-template-columns: 1fr 16px; 
    padding:5px
  }
  .deleteicon{
    color: rgb(194, 40, 40);
    float: right;
    margin: auto;
  }
  .padd {
    padding: 10px;
  }
  .paddfailovercheck {
    padding-top: 10px;
  }
  .loader{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
  }
</style>
